import { useNavigate } from "react-router-dom";
import Back from "../../../../../Components/Back";
import Incoming from "../../invoices/Incoming";

export default function Invoices({ setCard }) {

  const navigate = useNavigate()

  return (
    <>
      <Back onClick={() => {
        navigate("/dashboard")
      }} />
      <Incoming />
    </>
  );
}